import React, { useEffect, useState } from 'react';

import $ from "jquery";

import AdviceSection from '../common/AdviceSection';
import SelectForceProfile from '../common/subMenuTabs/SelectForceProfile';
import MapChart from '../common/charts/MapChart';
import Methodology from '../common/Methodology';

import { getCountryDataMap } from '../../api';

import images from '../../style/img/flag/images';

const WorkforceProfile = props => {
	
	const currentPath = '/osh-context/workforce-profile/';
	const country = props.country;
	const [indicator, setIndicator] = useState(props.indicator);
	const [datasetIndicator1, setDatasetIndicator1] = useState(null);
	const [datasetIndicator2, setDatasetIndicator2] = useState(null);
	const [datasetIndicator3, setDatasetIndicator3] = useState(null);
	const [datasetIndicator4, setDatasetIndicator4] = useState(null);
	const [title, setTitle] = useState(props.literals.L23531);
	const [disabled, setDisabled] = useState("disabled");
	const [unselect, setUnselect] = useState(true);
	const [visible, setVisible] = useState(true);
	const [select, setSelect] = useState("Median age of population");
	const [countries, setCountries] = useState([]);
	const [countryCode, setCountryCode] = useState("");
	const [countryName, setCountryName] = useState("");
	const [flag, setFlag] = useState('');
	const [data, setData] = useState({
		employment:"",
		mediaAge:"",
		unemployment:"",
		female:"",
		male:"",
		total:""
	});
	const [euData, setEUData] = useState({
		employment:"",
		mediaAge:"",
		unemployment:"",
		female:"",
		male:"",
		total:""
	});
	const [filters, setFilters] = useState({
		countries: []
	})

	const handleSearch = (country) => {
		if (country == 'Czech Republic')
		{
			country = 'Czechia';
		}
		setCountryName(country);
		setVisible(false);
	}

	const scrollToTop = () => {
		let element = $( ".survey--map--block" );
		
		let offset = element.offset();     
		if($(window).scrollTop()>=offset.top){
			$( ".survey--map--block" ).addClass('fixed');
		} else {
			$( ".survey--map--block" ).removeClass('fixed');
		}
	}

	const getLoadData = (countryName, datasetIndicator1, datasetIndicator2, datasetIndicator3, datasetIndicator4) => {

		getCountryDataMap(datasetIndicator1, datasetIndicator2, datasetIndicator3, datasetIndicator4)
		.then((res) => {
			const option = res.resultset.find( (element) => element.countryName == countryName && element.countryName != 'EU27' && element.countryName != 'EU28' );
			const euOption = res.resultset.find( (element) => element.countryName == 'EU27' || element.countryName == 'EU28' );
			try {
				if (euOption != undefined)
				{
					const euData = euOption.data;
					setCountries(res.resultset);
					setEUData({
						countryCode: euOption.countryCode,
						countryName: euOption.countryName,
						employment: euData['Ageing workers (55 to 64) employment rate'],
						mediaAge: euData['Median age of population'],
						unemployment: euData['Unemployment rate'],
						female: euData['Total, male and female employment rate - Female'],
						male: euData['Total, male and female employment rate - Male'],
						total: euData['Total, male and female employment rate - Total']
					});
				}

				if (option != undefined) {
					const data = option.data
					setCountryName(option.countryName);
					setCountryCode(option.countryCode);
					setFlag(option.countryCode.toLowerCase());
					setData({
						employment: data['Ageing workers (55 to 64) employment rate'],
						mediaAge: data['Median age of population'],
						unemployment: data['Unemployment rate'],
						female: data['Total, male and female employment rate - Female'],
						male: data['Total, male and female employment rate - Male'],
						total: data['Total, male and female employment rate - Total']
					});
				}
			} catch (err) {
				console.log('Error: ', err)
			}				
		})
	}

	useEffect(() => {
		// Update the title of the page
		document.title = props.literals.L22004 +  " - " + props.literals.L22020 + " - " + props.literals.L363;

		if(indicator != 'median-age'){
			switch(indicator){
				case "employment-rate" :
					setDisabled("");
					setTitle(props.literals.L20621 + ' - ' + props.literals.L23544);
					setSelect('Ageing workers (55 to 64) employment rate');
					setIndicator('employment-rate');
					break;
				case "ageing-workers" :
					setDisabled("");
					setTitle(props.literals.L20621 + ' - ' + props.literals.L23544);
					setSelect('Ageing workers (55 to 64) employment rate');
					break;
				case "unemployment-rate":
					setDisabled("disabled");
					setTitle(props.literals.L23570);
					setSelect('Unemployment rate');
					setIndicator('unemployment-rate');
					break;
			}

			if(props.subIndicator != 'ageing-workers'){
				switch(props.subIndicator){
					case "female":
						setSelect('Total, male and female employment rate - Female');
						setTitle(props.literals.L20621 + ' - ' + props.literals.L444);
						break;
					case "male":
						setSelect('Total, male and female employment rate - Male');
						setTitle(props.literals.L20621 + ' - ' + props.literals.L443);
						break;
					case "total":
						setSelect('Total, male and female employment rate - Total');
						setTitle(props.literals.L20621 + ' - ' + props.literals.L442);
						break;
				}
			}
		}

		getLoadData(countryName);

		addEventListener('scroll', scrollToTop)

		if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
			$('body').addClass('mobile-device');
			$('.print--block').addClass('hide');
			$('.zoom--text').addClass('hide');
		} else {
			$('body').removeClass('mobile-device');
			$('.print--block').removeClass('hide');
			$('.zoom--text').removeClass('hide');
		}

		return () => {
			window.removeEventListener('scroll', scrollToTop);
		};
	}, []);

	useEffect(() => {
		getLoadData(countryName, datasetIndicator1, datasetIndicator2, datasetIndicator3, datasetIndicator4);
	}, [countryName, datasetIndicator1, datasetIndicator2, datasetIndicator3, datasetIndicator4]);

	const handleCallbackCountry = (countryCallback) => {
		const countryFilter = filters.countries;
		const countryCode = filters.countries.find((country) => country.code == countryCallback.code)

		if (countryCode?.code != countryCallback.code) {
			setFilters( {...filters, countries: [...countryFilter, countryCallback ] });
		} else {
			const index = filters.countries.findIndex( (country) => country.code == countryCallback.code );
			const newCountryFilters = filters.countries;
			newCountryFilters.splice(index, 1);
			setFilters({ ...filters, countries: newCountryFilters });
		}
	}

	const onSelectCountryTag = (countryCode) => {
		return () => {
			const countryIndex = filters.countries.findIndex( (country) => country.code == countryCode );
			const newArray = filters.countries;
			newArray.splice( countryIndex, 1 );
			setFilters({...filters, countries: newArray });
		}
	}

	const refresh = () => {
		setVisible(true);
		setUnselect(!unselect);
		setCountryCode("");
		setCountryName("");
		setFlag('');
		setData({
			employment:"",
			mediaAge:"",
			unemployment:"",
			female:"",
			male:"",
			total:""
		})
	}

	const callbackSelect = (option)=>{
		refresh();
		
		setSelect(option);

		switch(option){
			case "employment-rate" :
				setDisabled("");
				setTitle(props.literals.L20621 + ' - ' + props.literals.L23544);
				setSelect('Ageing workers (55 to 64) employment rate');
				setIndicator('employment-rate');
				break;
			case "ageing-workers" :
				setDisabled("");
				setTitle(props.literals.L20621 + ' - ' + props.literals.L23544);
				setSelect('Ageing workers (55 to 64) employment rate');
				break;
			case "median-age":
				setDisabled("disabled");
				setTitle(props.literals.L23531);
				setSelect('Median age of population');
			break;
			case "unemployment-rate":
				setDisabled("disabled");
				setTitle(props.literals.L23570);
				setSelect('Unemployment rate');
				setIndicator('unemployment-rate');
				break
			case "female":
				setSelect('Total, male and female employment rate - Female');
				setTitle(props.literals.L20621 + ' - ' + this.props.literals.L444);
				break
			case "male":
				setSelect('Total, male and female employment rate - Male');
				setTitle(props.literals.L20621 + ' - ' + props.literals.L443);
				break
			case "total":
				setSelect('Total, male and female employment rate - Total');
				setTitle(props.literals.L20621 + ' - ' + props.literals.L442);
				break
		}
	}

	const callbackDataset = (datasetIndicator1, datasetIndicator2, datasetIndicator3, datasetIndicator4) =>
	{
		if (datasetIndicator1 != null && datasetIndicator2 != null && datasetIndicator3 != null && datasetIndicator4 != null)
		{
			// Only set the datasets if the three of them are set to ensure that all the datasets can be included in the call to the WS
			setDatasetIndicator1(datasetIndicator1);
			setDatasetIndicator2(datasetIndicator2);
			setDatasetIndicator3(datasetIndicator3);
			setDatasetIndicator4(datasetIndicator4);
		}		
	}

	const callbackResetFilter = () => {
		setDatasetIndicator1(null);
		setDatasetIndicator2(null);
		setDatasetIndicator3(null);
		setDatasetIndicator4(null);
	}

	return(
		<div className="workforce--page">

			<AdviceSection literals={props.literals} section={["osh-context","workforce-profile"]} methodologyData={{section: 'osh-context', subsection: 'Workforce profile', indicator: 37}} />
			
			<div className="filter--indicator--block container">
				<SelectForceProfile 
					selectCountries={ countries }
					callbackSelect={ callbackSelect }
					locationPath={ currentPath }
					literals={ props.literals }
					indicator={ props.indicator }
					secondIndicator={ props.subIndicator }
					filters={ filters }
					onCallbackCountry={ handleCallbackCountry }
					callbackDataset= { callbackDataset }
					callbackResetFilter={ callbackResetFilter }
				/>
			</div>
			<div className="line background-main-light"></div>
			
			<section className="container-full nopadding">
				<section className="survey--map--block">
					<div className="sticky--wraper">
						<div className="legend--block eu">
							<div className="map--legend--block map--eu--legend container">
								<div className="matrix--header--elements">
									<img className="flags--wrapper" src={require("../../style/img/flag/eu28.png")} />
									<h2 className="country title-section main-color">{euData.countryName}</h2>
								</div>
								<ul className="matrix--elements--data">
									<li>
										<label>{props.literals.L20615}</label>
										<div><span className="data">{euData.mediaAge}</span> <span className="data-text">{props.literals.L20620}</span></div>
									</li>
									<li>
										<label className="">{props.literals.L20616}</label>
										<div><span className="data">{euData.employment}</span> <span className="data-text">%</span></div>
									</li>
									<li>
										<label className="">{props.literals.L20619}</label>
										<div><span className="data">{euData.female}</span> <span className="data-text">%</span></div>
									</li>
									<li>
										<label className="">{props.literals.L20618}</label>
										<div><span className="data" >{euData.male}</span> <span className="data-text">%</span></div>
									</li>
									<li>
										<label className="">{props.literals.L20617}</label>
										<div><span className="data" >{euData.total}</span> <span className="data-text">%</span></div>
									</li>
									<li>
										<label className="">{props.literals.L22125}</label>
										<div><span className="data">{euData.unemployment}</span> <span className="data-text">%</span></div>
									</li>
								</ul>
							</div>								
						</div>

						<div className="legend--block">
							{/* When visible is false, a Country has been selected in the map and its data is shown */}
							{ visible ? 
								(
									<div>
										<p className="help-text container"><strong>Click on a country to compare</strong> the data <span className="exclamation" aria-hidden="true"></span></p> 
									</div>
								) : (
									<div className="map--legend--block map--countries--legend container">
										<div className="matrix--header--elements">
											<img className="flags--wrapper" src={ images[flag] } />
											<h2 className="country title-section main-color">{ countryName }</h2>
										</div>
										<ul className="matrix--elements--data">
											<li>
												<label>{ props.literals.L20615 }</label>
												<div><span className="data">{ data.mediaAge }</span> <span className="data-text">{ props.literals.L20620 }</span></div>
											</li>
											<li>
												<label className="">{ props.literals.L20616 }</label>
												<div><span className="data">{ data.employment }</span> <span className="data-text">%</span></div>
											</li>
											<li>
												<label className="">{ props.literals.L20619 }</label>
												<div><span className="data">{ data.female }</span> <span className="data-text">%</span></div>
											</li>
											<li>
												<label className="">{ props.literals.L20618 }</label>
												<div><span className="data" >{ data.male }</span> <span className="data-text">%</span></div>
											</li>
											<li>
												<label className="">{ props.literals.L20617 }</label>
												<div><span className="data">{ data.total }</span> <span className="data-text">%</span></div>
											</li>
											<li>
												<label className="">{ props.literals.L22125 }</label>
												<div><span className="data">{ data.unemployment }</span> <span className="data-text">%</span></div>
											</li>
										</ul>
										<span className="close-legend" onClick={ refresh }><i className="fa fa-times" ></i></span>
									</div>
								)
							}
						</div>
					</div>
					<div className="map--block center-text container">
						<p className="non-eu">{ props.literals.L22104 }</p>					
						<MapChart 
							handleSearch={ handleSearch } 
							unselect={ unselect } 
							select={ select } 
							title={ title }
							datasetIndicator1 = { datasetIndicator1 }
							datasetIndicator2 = { datasetIndicator2 }
							datasetIndicator3 = { datasetIndicator3 }
							datasetIndicator4 = { datasetIndicator4 }								
						/>							
					</div>
				</section>
				<section className="survey--map--block-mobile">
					<div className="selected--tags-wrapper">
						{ filters && (
							<div>
								{ filters.countries.map((country) => (
									<span key={ country.code } className="selected-tag" onClick={ onSelectCountryTag(country.code) }>{ country.code == 'EU27_2020' ? '' : `${country.code}` } { country.name }</span>
								))}
							</div>
						)}
					</div>
					<div className="matrix--elements--wrapper">
						<div>
							{ filters.countries.length > 0 ? (
								/** It prints that are being selected */
								filters.countries.map((item) => (
									<div key={item.code} className="matrix--element eu27_2020">
										<div className="matrix--header--elements">
											<img className="flags--wrapper" src={ images[item.code.toLowerCase()] } />
											<h2 className="country title-section main-color">{ item.name }</h2>
										</div>
										<div className="matrix--content--elements">
											<ul className="matrix--elements--data">
												<li>
													<label className="">{ props.literals.L20615 }</label>
													<div><span className="data">{ item.data['Median age of population'] }</span> <span className="data-text">{ props.literals.L20620 }</span></div>
												</li>
												<li>
													<label className="">{ props.literals.L20616 }</label>
													<div><span className="data" >{ item.data['Ageing workers (55 to 64) employment rate'] }</span> <span className="data-text">%</span></div>
												</li>
												<li>
													<label className="">{ props.literals.L20617 }</label>
													<div><span className="data" >{ item.data['Total, male and female employment rate - Total'] }</span> <span className="data-text">%</span></div>
												</li>
												<li>
													<label className="">{ props.literals.L20618 }</label>
													<div><span className="data" >{ item.data['Total, male and female employment rate - Male'] }</span> <span className="data-text">%</span></div>
												</li>
												<li>
													<label className="">{ props.literals.L20619 }</label>
													<div><span className="data">{ item.data['Total, male and female employment rate - Female'] }</span> <span className="data-text">%</span></div>
												</li>
												<li>
													<label className="">{ props.literals.L291 }</label>
													<div><span className="data">{ item.data['Unemployment rate'] }</span> <span className="data-text">%</span></div>
												</li>
											</ul>
										</div>
									</div>
								))
							) : (
								/** It print all countries when there are no countries selected */
								<React.Fragment>
									{  countries.filter((item) => item.countryCode == 'EU27_2020' || item.countryCode == 'EU28').map((item) => (
										<div key={ item.countryCode } className={`matrix--element ${item.countryCode.toLowerCase()}`}>
											<div className="matrix--header--elements">
												<img className="flags--wrapper" src={images['eu28']} />
												<h2 className="country title-section main-color">{ item.countryName }</h2>
											</div>
											<div className="matrix--content--elements">
												<ul className="matrix--elements--data">
													<li>
														<label className="">{ props.literals.L20615 }</label>
														<div><span className="data">{ item.data['Median age of population'] }</span> <span className="data-text">{ props.literals.L20620 }</span></div>
													</li>
													<li>
														<label className="">{ props.literals.L20616 }</label>
														<div><span className="data" >{ item.data['Ageing workers (55 to 64) employment rate'] }</span> <span className="data-text">%</span></div>
													</li>
													<li>
														<label className="">{ props.literals.L20617 }</label>
														<div><span className="data" >{ item.data['Total, male and female employment rate - Total'] }</span> <span className="data-text">%</span></div>
													</li>
													<li>
														<label className="">{ props.literals.L20618 }</label>
														<div><span className="data" >{ item.data['Total, male and female employment rate - Male'] }</span> <span className="data-text">%</span></div>
													</li>
													<li>
														<label className="">{ props.literals.L20619 }</label>
														<div><span className="data">{ item.data['Total, male and female employment rate - Female'] }</span> <span className="data-text">%</span></div>
													</li>
													<li>
														<label className="">{ props.literals.L291 }</label>
														<div><span className="data">{ item.data['Unemployment rate'] }</span> <span className="data-text">%</span></div>
													</li>
												</ul>
											</div>
										</div>
									))}
									{ countries.filter((item) => item.countryCode != 'EU27_2020' && item.countryCode != 'EU28').map((item) => (
										<div key={ item.countryCode } className={`matrix--element ${item.countryCode.toLowerCase()}`}>
											<div className="matrix--header--elements">
												<img className="flags--wrapper" src={images[item.countryCode.toLowerCase()]} />
												<h2 className="country title-section main-color">{ item.countryName }</h2>
											</div>
											<div className="matrix--content--elements">
												<ul className="matrix--elements--data">
													<li>
														<label className="">{ props.literals.L20615 }</label>
														<div><span className="data">{ item.data['Median age of population'] }</span> <span className="data-text">{ props.literals.L20620 }</span></div>
													</li>
													<li>
														<label className="">{ props.literals.L20616 }</label>
														<div><span className="data" >{ item.data['Ageing workers (55 to 64) employment rate'] }</span> <span className="data-text">%</span></div>
													</li>
													<li>
														<label className="">{ props.literals.L20617 }</label>
														<div><span className="data" >{ item.data['Total, male and female employment rate - Total'] }</span> <span className="data-text">%</span></div>
													</li>
													<li>
														<label className="">{ props.literals.L20618 }</label>
														<div><span className="data" >{ item.data['Total, male and female employment rate - Male'] }</span> <span className="data-text">%</span></div>
													</li>
													<li>
														<label className="">{ props.literals.L20619 }</label>
														<div><span className="data">{ item.data['Total, male and female employment rate - Female'] }</span> <span className="data-text">%</span></div>
													</li>
													<li>
														<label className="">{ props.literals.L291 }</label>
														<div><span className="data">{ item.data['Unemployment rate'] }</span> <span className="data-text">%</span></div>
													</li>
												</ul>
											</div>
										</div>
									))}
								</React.Fragment>
							)}
						</div>
					</div>
				</section>
			</section>
			<Methodology literals={ props.literals } section={ 'Workforce profile' } />			
		</div>
	)
}
WorkforceProfile.displayName = 'WorkforceProfile';
export default WorkforceProfile;